export function ProgressBar({ 
  percent, 
  height = 5, 
  showLabel = true,
  color = "linear-gradient(90deg,#166534,#4ade80)",
  backgroundColor = "rgba(255,255,255,0.07)"
}) {
  return (
    <div style={{ width: "100%" }}>
      {showLabel && (
        <div 
          style={{ 
            display: "flex", 
            justifyContent: "space-between", 
            fontSize: "0.7rem", 
            color: "#6b7280", 
            marginBottom: "0.35rem" 
          }}
        >
          <span>Overall progress</span>
          <span style={{ color: "#4ade80" }}>{percent}%</span>
        </div>
      )}
      <div 
        style={{ 
          background: backgroundColor, 
          borderRadius: "99px", 
          height: `${height}px`, 
          overflow: "hidden" 
        }}
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div 
          style={{ 
            width: `${percent}%`, 
            height: "100%", 
            background: color, 
            borderRadius: "99px", 
            transition: "width 0.5s" 
          }} 
        />
      </div>
    </div>
  );
}

export function MiniProgress({ percent }) {
  return (
    <div 
      style={{ 
        background: "rgba(255,255,255,0.04)", 
        borderRadius: "8px", 
        padding: "0.6rem 0.85rem", 
        marginBottom: "1rem", 
        display: "flex", 
        alignItems: "center", 
        gap: "0.9rem" 
      }}
    >
      <div 
        style={{ 
          flex: 1, 
          background: "rgba(255,255,255,0.07)", 
          borderRadius: "99px", 
          height: "4px", 
          overflow: "hidden" 
        }}
      >
        <div 
          style={{ 
            width: `${percent}%`, 
            height: "100%", 
            background: "linear-gradient(90deg,#166534,#4ade80)", 
            borderRadius: "99px", 
            transition: "width 0.4s" 
          }} 
        />
      </div>
      <span style={{ fontSize: "0.72rem", color: "#4ade80", flexShrink: 0 }}>
        {percent}%
      </span>
    </div>
  );
}
